import { uuid } from "../../../../../../types/veboxModels";
import { VeBoxEquipmentFilters } from "../../../data/models/VeBoxEquipmentFilters";

export const createDeviceTypesFilter = (
	deviceTypeGuids: uuid[],
): VeBoxEquipmentFilters => {
	return {
		deviceFiltersCategory: {
			deviceModelGuids: deviceTypeGuids,
		},
	};
};
